







































import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { NavModule, ProfileModule } from "@/store";
import { MediaQuery } from '@/MediaQuery';
import { mdbBtn, mdbCol, mdbContainer, mdbRow } from 'mdbvue'
import DailyAllowance from './DailyAllowance.vue'
import ScheduledTransfer from './ScheduledTransfer.vue'
import SnackbarLimit from './SnackbarLimit.vue'
import { RouterUtils } from '@/router/RouterUtils'

// Define the props by using Vue's canonical way.
const BudgetWizardProps = Vue.extend({
  props: {
    budgetId: String,
    personId: String
  },
  mixins: [RouterUtils]
});

@Component({
  components: {
    DailyAllowance,
    ScheduledTransfer,
    SnackbarLimit,
    mdbBtn,
    mdbCol,
    mdbContainer,
    mdbRow
  }
})
export default class BudgetWizard extends BudgetWizardProps {
  // bankStore: BankModule = getModule(BankModule, this.$store);
  navStore: NavModule = getModule(NavModule, this.$store);
  profileStore: ProfileModule = getModule(ProfileModule, this.$store);
  MediaQuery = MediaQuery;

  budgetingSelected: any = ''
  budgetingOptions: any[] = [
        { text: 'Daily Allocation', value: 'allowance' },
        { text: 'Scheduled Availability', value: 'scheduled' },
        { text: 'Food/Drink Daily Limit', value: 'snackbar' }
  ]

  get isButtonDisabled (): boolean {
    if (
      this.isDailyAllowanceChecked ||
      this.isScheduledChecked ||
      this.isSnackbarChecked
    ) {
      return false
    }
    return true
  }
  get isDailyAllowanceChecked (): boolean {
    return this.budgetingSelected.indexOf('allowance') === 0
  }
  get isScheduledChecked (): boolean {
    return this.budgetingSelected.indexOf('scheduled') === 0
  }
  get isSnackbarChecked (): boolean {
    return this.budgetingSelected.indexOf('snackbar') === 0
  }
  get showDailyAllowanceSteps (): boolean {
    if (
      this.$route.hash === '#daily-allocation-form' ||
      this.$route.hash === '#daily-allocation-result'
    ) {
      return true
    }
    return false
  }
  get showScheduledTransferSteps (): boolean {
    if (
      this.$route.hash === '#scheduled-transfer-form' ||
      this.$route.hash === '#scheduled-transfer-result'
    ) {
      return true
    }
    return false
  }
  get showSnackbarLimitSteps (): boolean {
    if (
      this.$route.hash === '#snackbar-limit-form' ||
      this.$route.hash === '#snackbar-limit-result'
    ) {
      return true
    }
    return false
  }
  get showStartScreen (): boolean {
    if (
      !this.showDailyAllowanceSteps &&
      !this.showScheduledTransferSteps &&
      !this.showSnackbarLimitSteps
    ) {
      return true
    }
    return false
  }

  // @Watch("$route", { immediate: true, deep: true })
  // onRouteChange(newRoute: any, oldRoute: any): void {
  //   // console.log("deposits route", this.$route, oldVal, newVal);
  //   // if (oldRoute.hash !== undefined && newRoute.hash !== oldRoute.hash) {
  //   //   // something?
  //   // }
  // }
  /* *** method elements: mixins, methods *** */
  // methods: {
  //   ...mapGetters('bank', ['getAuthorizedActivePersons']),
  //   ...mapMutations('nav', ['pushBackbarStack', 'resetBackbarStack']),
  handleNextClick () {
    // add route to stack
    this.navStore.pushBackbarStack(this.$route)
    // console.log(this.budgetingSelected)
    // console.log('selected daily allocation:', this.selectedDailyAllowance)
    // activate next section
    if (this.isDailyAllowanceChecked) {
      // console.log('Selected daily allocation...')
      window.location.hash = 'daily-allocation-form'
    }
    if (this.isScheduledChecked) {
      window.location.hash = 'scheduled-transfer-form'
    }
    if (this.isSnackbarChecked) {
      window.location.hash = 'snackbar-limit-form'
    }
  }
  displayStartScreen () {
    // console.log('Display start screen...')
  }

  /* *** lifecycle elements: created, mounted *** */
  created () {}
  mounted () {}
}
